import type { FaireProductEntity } from "../../entity_types/product";

export const p_ywdksv79n8: FaireProductEntity = {
  token: "p_ywdksv79n8",
  type: "product",
  name: "Hawaii Market 100% Hawaiian honey 2oz/ 36c",
  brandName: "Hawaiian King Candies",
  imageUrl:
    "https://cdn.faire.com/fastly/2ee0f87fa3515bebdf08869d628d3486a5bc643de2e11c3d605838fc6950d492.jpeg",
  priceDollars: 4.46,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/364312c1111690d97cce7a75cc228a7d91e002011e22673febd294bc04870165.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
